import React from "react";
function ServiceRemark(props) {
  const handleClick = (event) => {
    event.target.select();
  };
  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>Service Remarks</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn">
              <i
                className="fa-regular fa-rectangle-xmark"
                onClick={(e) => props.Close(props.strRemarkType)}
              ></i>
            </span>
          </div>
        </div>
        <div className="popup-body p-2">
          <label>Remarks</label>
          <textarea
            style={{ height: "100px" }}
            className="form-control rounded"
            aria-label="With textarea"
            id="strRemark"
            onClick={handleClick}
            name="strRemark"
            onChange={(e) => props.onChangeEvent(e.target.value)}
            autoComplete="off"
            value={props.strRemark}
            autoFocus
          ></textarea>
        </div>
      </div>
    </div>
  );
}

export default ServiceRemark;
